import { SimulationStatus } from "../interfaces/DTO/simulation";

export function formatSimulationStatus(status: SimulationStatus): string {
  const labels: Record<SimulationStatus, string> = {
    [SimulationStatus.DRAFT]: "טיוטה",
    [SimulationStatus.FINALIZED]: "סופי",
    [SimulationStatus.SELECTED]: "נבחר לתצוגה בדוח",
    [SimulationStatus.APPROVED]: "אושר לביצוע",
    [SimulationStatus.DISCARDED]: "מבוטל",
  };
  return labels[status] ?? status;
}

/**
 * הסימולציה שמוצגת בדוח / בפגישה: נבחרה לתצוגה, וגם אחרי שאושרה לביצוע (APPROVED) היא נשארת המוצגת.
 */
export function isSelectedForDisplay(status: SimulationStatus | undefined | null): boolean {
  return status === SimulationStatus.SELECTED || status === SimulationStatus.APPROVED;
}

export function colorSimulationStatus(
  status: SimulationStatus
): "default" | "primary" | "success" | "error" {
  const colors: Record<SimulationStatus, "default" | "primary" | "success" | "error"> = {
    [SimulationStatus.DRAFT]: "default",
    [SimulationStatus.FINALIZED]: "primary",
    [SimulationStatus.SELECTED]: "success",
    [SimulationStatus.APPROVED]: "success",
    [SimulationStatus.DISCARDED]: "error",
  };
  return colors[status] ?? "default";
}
